// Placeholder — Phase 2 (Akku-Stationen + Reservierung).
export function BatteryPage() {
  return (
    <div className="absolute inset-0 p-4">
      <h1 className="text-xl font-semibold mb-3">Swap battery</h1>
      <p className="text-white/60 text-sm">
        Coming in Phase 2/3: station overview with traffic-light status
        (full/half/empty), battery reservation, QR flow for the swap.
      </p>
    </div>
  );
}
